"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useEffect, useState } from "react";
import { ApiWave } from "@/generated/models/ApiWave";
import { ApiWaveCreditType } from "@/generated/models/ApiWaveCreditType";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAt } from "@fortawesome/free-solid-svg-icons";
import { useWaveNotificationSubscription } from "@/hooks/useWaveNotificationSubscription";
import { commonApiDelete, commonApiPost } from "@/services/api/common-api";
import { useAuth } from "@/components/auth/Auth";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
import { Spinner } from "@/components/dotLoader/DotLoader";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
const CREDIT_TYPE_LABELS: Record<ApiWaveCreditType, string> = {
  [ApiWaveCreditType.Tdh]: "TDH",
  [ApiWaveCreditType.Rep]: "REP"
};
interface WaveRatingProps {
  readonly wave: ApiWave;
}
export default function WaveNotificationSettings(t0) {
  const $ = _c(39);
  const {
    wave
  } = t0;
  const {
    seizeSettings
  } = useSeizeSettings();
  const disableSelection = wave.metrics.subscribers_count >= seizeSettings.all_drops_notifications_subscribers_limit;
  const [following, setFollowing] = useState(false);
  const [isAllEnabled, setIsAllEnabled] = useState();
  const {
    data,
    refetch
  } = useWaveNotificationSubscription(wave);
  const {
    setToast
  } = useAuth();
  const [loading, setLoading] = useState(false);
  const [loadingTarget, setLoadingTarget] = useState(null);
  let t1;
  if ($[0] !== data?.subscribed || $[1] !== disableSelection) {
    t1 = () => {
      setIsAllEnabled(data?.subscribed && !disableSelection);
    };
    $[0] = data?.subscribed;
    $[1] = disableSelection;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== data || $[4] !== disableSelection) {
    t2 = [data, disableSelection];
    $[3] = data;
    $[4] = disableSelection;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] !== isAllEnabled || $[7] !== refetch || $[8] !== setToast || $[9] !== wave.id) {
    t3 = async enableAll => {
      if (enableAll === isAllEnabled) {
        return;
      }
      setLoadingTarget(enableAll ? "all" : "mentions");
      setLoading(true);
      if (enableAll) {
        ;
        try {
          await commonApiPost({
            endpoint: `notifications/wave-subscription/${wave.id}`,
            body: {}
          });
          await refetch();
          setLoading(false);
          setLoadingTarget(null);
        } catch (t4) {
          const error = t4;
          setLoading(false);
          setLoadingTarget(null);
          setToast({
            message: typeof error === "string" ? error : "Unable to subscribe to all drops",
            type: "error"
          });
        }
      } else {
        ;
        try {
          await commonApiDelete({
            endpoint: `notifications/wave-subscription/${wave.id}`
          });
          await refetch();
          setLoading(false);
          setLoadingTarget(null);
        } catch (t5) {
          const error_0 = t5;
          setLoading(false);
          setLoadingTarget(null);
          setToast({
            message: typeof error_0 === "string" ? error_0 : "Unable to subscribe to mentions",
            type: "error"
          });
        }
      }
    };
    $[6] = isAllEnabled;
    $[7] = refetch;
    $[8] = setToast;
    $[9] = wave.id;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const toggleNotifications = t3;
  let t4;
  let t5;
  if ($[11] !== refetch || $[12] !== wave.subscribed_actions.length) {
    t4 = () => {
      setFollowing(!!wave.subscribed_actions.length);
      refetch();
    };
    t5 = [wave.subscribed_actions.length, refetch];
    $[11] = refetch;
    $[12] = wave.subscribed_actions.length;
    $[13] = t4;
    $[14] = t5;
  } else {
    t4 = $[13];
    t5 = $[14];
  }
  useEffect(t4, t5);
  let t6;
  if ($[15] !== isAllEnabled) {
    t6 = () => isAllEnabled ? "Click to switch to mentions-only notifications" : "";
    $[15] = isAllEnabled;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const getMentionsTooltip = t6;
  let t7;
  if ($[17] !== disableSelection || $[18] !== isAllEnabled || $[19] !== seizeSettings.all_drops_notifications_subscribers_limit) {
    t7 = () => {
      if (disableSelection) {
        return `'All' notifications unavailable for waves with ${seizeSettings.all_drops_notifications_subscribers_limit.toLocaleString()}+ followers.`;
      }
      return !isAllEnabled ? "Click to enable notifications for all drops" : "";
    };
    $[17] = disableSelection;
    $[18] = isAllEnabled;
    $[19] = seizeSettings.all_drops_notifications_subscribers_limit;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  const getAllTooltip = t7;
  const getActiveButtonStyle = _temp;
  const getInactiveButtonStyle = _temp2;
  const getDisabledButtonStyle = _temp3;
  if (!following) {
    return null;
  }
  let t8;
  if ($[21] !== getMentionsTooltip || $[22] !== isAllEnabled || $[23] !== loading || $[24] !== loadingTarget || $[25] !== toggleNotifications || $[26] !== wave.id) {
    t8 = isAllEnabled ? <OverlayTrigger overlay={<Tooltip id={`mentions-tooltip-${wave.id}`} placement="top">{getMentionsTooltip()}</Tooltip>}><button disabled={loading} onClick={() => toggleNotifications(false)} className={`tw-px-3 tw-py-2 tw-rounded-md tw-border-0 tw-transition tw-duration-300 tw-ease-out tw-flex tw-items-center tw-justify-center ${getInactiveButtonStyle()}`} aria-label="Receive mentions-only notifications">{loading && loadingTarget === "mentions" ? <Spinner dimension={12} /> : <FontAwesomeIcon icon={faAt} className="tw-size-3.5 tw-flex-shrink-0" />}</button></OverlayTrigger> : <button disabled={loading} onClick={() => toggleNotifications(false)} className={`tw-px-3 tw-py-2 tw-rounded-md tw-border-0 tw-transition tw-duration-300 tw-ease-out tw-flex tw-items-center tw-justify-center ${getActiveButtonStyle()}`} aria-label="Receive mentions-only notifications">{loading && loadingTarget === "mentions" ? <Spinner dimension={12} /> : <FontAwesomeIcon icon={faAt} className="tw-size-3.5 tw-flex-shrink-0" />}</button>;
    $[21] = getMentionsTooltip;
    $[22] = isAllEnabled;
    $[23] = loading;
    $[24] = loadingTarget;
    $[25] = toggleNotifications;
    $[26] = wave.id;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== disableSelection || $[29] !== getAllTooltip || $[30] !== isAllEnabled || $[31] !== loading || $[32] !== loadingTarget || $[33] !== toggleNotifications || $[34] !== wave.id) {
    t9 = disableSelection ? <OverlayTrigger overlay={<Tooltip id={`all-tooltip-${wave.id}`} placement="top">{getAllTooltip()}</Tooltip>}><button disabled={true} className={`tw-px-3 tw-py-2 lg:tw-px-2.5 lg:tw-py-1.5 tw-rounded-md tw-border-0 tw-transition tw-duration-300 tw-ease-out tw-flex tw-items-center tw-justify-center ${getDisabledButtonStyle()}`} aria-label="Receive all notifications">{loading && loadingTarget === "all" ? <Spinner dimension={12} /> : <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="tw-size-4 tw-flex-shrink-0"><path strokeLinecap="round" strokeLinejoin="round" d="M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 1 1 0-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 0 1-1.44-4.282m3.102.069a18.03 18.03 0 0 1-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 0 1 8.835 2.535M10.34 6.66a23.847 23.847 0 0 0 8.835-2.535m0 0A23.74 23.74 0 0 0 18.795 3m.38 1.125a23.91 23.91 0 0 1 1.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 0 0 1.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 0 1 0 3.46" /></svg>}</button></OverlayTrigger> : isAllEnabled ? <button disabled={loading} onClick={() => toggleNotifications(true)} className={`tw-px-3 tw-py-2 lg:tw-px-2.5 lg:tw-py-1.5 tw-rounded-md tw-border-0 tw-transition tw-duration-300 tw-ease-out tw-flex tw-items-center tw-justify-center ${getActiveButtonStyle()}`} aria-label="Receive all notifications">{loading && loadingTarget === "all" ? <Spinner dimension={12} /> : <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="tw-size-4 tw-flex-shrink-0"><path strokeLinecap="round" strokeLinejoin="round" d="M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 1 1 0-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 0 1-1.44-4.282m3.102.069a18.03 18.03 0 0 1-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 0 1 8.835 2.535M10.34 6.66a23.847 23.847 0 0 0 8.835-2.535m0 0A23.74 23.74 0 0 0 18.795 3m.38 1.125a23.91 23.91 0 0 1 1.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 0 0 1.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 0 1 0 3.46" /></svg>}</button> : <OverlayTrigger overlay={<Tooltip id={`all-tooltip-${wave.id}`} placement="top">{getAllTooltip()}</Tooltip>}><button disabled={loading} onClick={() => toggleNotifications(true)} className={`tw-px-3 tw-py-2 lg:tw-px-2.5 lg:tw-py-1.5 tw-rounded-md tw-border-0 tw-transition tw-duration-300 tw-ease-out tw-flex tw-items-center tw-justify-center ${getInactiveButtonStyle()}`} aria-label="Receive all notifications">{loading && loadingTarget === "all" ? <Spinner dimension={12} /> : <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="tw-size-4 tw-flex-shrink-0"><path strokeLinecap="round" strokeLinejoin="round" d="M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 1 1 0-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 0 1-1.44-4.282m3.102.069a18.03 18.03 0 0 1-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 0 1 8.835 2.535M10.34 6.66a23.847 23.847 0 0 0 8.835-2.535m0 0A23.74 23.74 0 0 0 18.795 3m.38 1.125a23.91 23.91 0 0 1 1.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 0 0 1.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 0 1 0 3.46" /></svg>}</button></OverlayTrigger>;
    $[28] = disableSelection;
    $[29] = getAllTooltip;
    $[30] = isAllEnabled;
    $[31] = loading;
    $[32] = loadingTarget;
    $[33] = toggleNotifications;
    $[34] = wave.id;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  let t10;
  if ($[36] !== t8 || $[37] !== t9) {
    t10 = <div className="tw-space-y-1.5"><div className="tw-flex tw-items-center tw-justify-between tw-gap-1.5"><div className="tw-flex tw-items-center tw-whitespace-nowrap tw-h-10 lg:tw-h-9 tw-px-1 tw-text-xs tw-border tw-border-iron-700 tw-border-solid tw-rounded-lg tw-overflow-hidden">{t8}{t9}</div></div></div>;
    $[36] = t8;
    $[37] = t9;
    $[38] = t10;
  } else {
    t10 = $[38];
  }
  return t10;
}
function _temp3() {
  return "tw-text-iron-500 tw-bg-transparent tw-cursor-not-allowed";
}
function _temp2() {
  return "tw-text-iron-400 desktop-hover:hover:tw-text-iron-300 tw-bg-transparent";
}
function _temp() {
  return "tw-bg-iron-800 tw-text-primary-400 tw-font-medium";
}